import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export function LegalLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-background grain">
      <Navbar />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight">{title}</h1>
        {subtitle && <p className="text-zinc-500 mt-3">{subtitle}</p>}
        <div className="mt-10 space-y-8 text-zinc-300 leading-relaxed text-[15px]">{children}</div>
      </div>
      <Footer />
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-xl font-bold text-white mb-2">{title}</h2>
      <div className="space-y-2 text-zinc-400">{children}</div>
    </section>
  );
}
